import { render, staticRenderFns } from "./Thead.vue?vue&type=template&id=4228312a&scoped=true&"
import script from "./Thead.vue?vue&type=script&lang=js&"
export * from "./Thead.vue?vue&type=script&lang=js&"
import style0 from "./Thead.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Thead.vue?vue&type=style&index=1&id=4228312a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4228312a",
  null
  
)

export default component.exports